import { Component, Input, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { IScoreMessageAdherence } from 'src/app/interfaces/iscore-message-adherence';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-results-message-adherence',
  templateUrl: './results-message-adherence.component.html',
  styleUrls: ['./results-message-adherence.component.scss'],
  standalone: false
})
export class ResultsMessageAdherenceComponent {
  @Input() messageAdherenceArray: IScoreMessageAdherence[] | null | undefined = [];
  @Input() practiceCallUuid: string = "";
  @ViewChild(MatMenuTrigger) tooltipMenu!: MatMenuTrigger;

  constructor(
    private clipboard: Clipboard,
  ) { }

  copyText() {
    this.clipboard.copy(this.practiceCallUuid);
    this.tooltipMenu.openMenu();

    setTimeout(() => {
      this.tooltipMenu.closeMenu();
    }, 3000); 
  }
}
